import { render, staticRenderFns } from "./CreateTaskModal.vue?vue&type=template&id=588bd081&"
import script from "./CreateTaskModal.vue?vue&type=script&lang=js&"
export * from "./CreateTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateTaskModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports